import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6u4myhnjf: FaireProductEntity = {
  token: "p_d6u4myhnjf",
  type: "product",
  name: "Walleye Lakes Sticker - Pack of 24",
  brandName: "218 Clothing + Gift",
  imageUrl:
    "https://cdn.faire.com/fastly/d04b97b7eb62f615ae0b6317c4b7d9f6ee2179f4ed1c6229d4e157c3abb7444b.jpeg",
  priceDollars: 24,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/335d0de9e8f1a7933884464a9b9fa06b0f1e42221b2ea2d48553bd312067d291.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
